
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("habRv", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $WNsSX = parcelRequire("WNsSX");


var $hRnS5 = parcelRequire("hRnS5");







function $35beb435b76f50f4$export$f9718e664221d42a({ render: render }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContextConsumer), null, (actions)=>render(actions));
}



var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $6UYek = parcelRequire("6UYek");





var $cZa7r = parcelRequire("cZa7r");


var $4gEXU = parcelRequire("4gEXU");

function $0779e224f4e996ea$export$6f846e47e87c2a09() {
    const { handleClose: handleClose } = (0, $cZa7r.useAnnotationsDispatch)();
    const onConfirm = (0, $cozmU.useCallback)(()=>{
        handleClose();
    }, [
        handleClose
    ]);
    (0, $4gEXU.usePreemptiveGate)({
        onConfirm: onConfirm
    });
    return null;
}



var $jmjWc = parcelRequire("jmjWc");





var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $a33Aa = parcelRequire("a33Aa");


var $gczDe = parcelRequire("gczDe");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");





var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");





var $ep3mz = parcelRequire("ep3mz");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $9wGTI = parcelRequire("9wGTI");


var $8WQTF = parcelRequire("8WQTF");


var $lb2Lp = parcelRequire("lb2Lp");


var $aSsfA = parcelRequire("aSsfA");


var $1ZGYV = parcelRequire("1ZGYV");


var $eTcMK = parcelRequire("eTcMK");


var $ifBRq = parcelRequire("ifBRq");

const $61084f20d36cc3f6$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
const $61084f20d36cc3f6$export$3cf51438c4a7a1a = ({ rendererRef: rendererRef, flags: flags })=>{
    const hasHandledCommentLink = (0, $cozmU.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const commentId = focusedCommentId || replyToCommentId || editCommentId;
    const skipNewFlow = !commentId;
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow || !foundComment?.parentId
        }
    });
    const queryParamData = (0, $cozmU.useMemo)(()=>{
        if (!commentError && !commentLoading && foundComment) {
            const location = foundComment.location;
            const parentId = foundComment.parentId;
            const parentLocation = parentId && !parentError && !parentLoading && parentComment ? parentComment.location : undefined;
            // Return the data if this is a root commment (it doesn't have a parent comment) and we
            // have just that comment's data or if it's a reply and we also have a parent comment
            // with valid data.  This prevents returning incomplete data while parent comment is
            // loading, which causes the dependent memoized items to be generated multiple times and in
            // turn causes multiple simulated annotation clicks when we only want one simulated click
            // after everything is loaded.
            if (!parentId || parentComment) return {
                location: location,
                parentId: parentId,
                parentLocation: parentLocation
            };
        }
        return undefined;
    // Note that we only want to regenerate this data only when the data contents has changed, not
    // when just the reference to the data has changed. Otherwise, we will generate the data twice:
    // once when useCommentById()'s single comment query returns with data and a second time when
    // the useAllCommentsData()'s query completes with similar data but a different reference -
    // which causes the dependent memoized items to be generated multiple times which in turn
    // causes multiple simulated annotation clicks when we only want one simulated click.
    // Note that looking at the comment IDs is sufficient because we only want to open/scroll to
    // the comment once even if other pieces of the comment's data change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentId,
        foundComment?.id,
        commentLoading,
        commentError,
        parentComment?.id,
        parentLoading,
        parentError
    ]);
    const queryParamDataExt = (0, $cozmU.useMemo)(()=>{
        const { location: location, parentLocation: parentLocation } = queryParamData || {};
        return location?.inlineMarkerRef ? {
            annotationId: location.inlineMarkerRef,
            isResolved: Boolean(location.inlineResolveProperties?.resolved)
        } : {
            annotationId: parentLocation?.inlineMarkerRef,
            isResolved: Boolean(parentLocation?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    // Create callback for handling replyToCommentId when comment is rendered
    const onReplyToCommentReady = (0, $cozmU.useCallback)(()=>{
        if (!replyToCommentId) return;
        const rawComment = foundComment;
        if (rawComment) {
            const commentWithAuthor = rawComment;
            // Get annotationId from the reply-to comment's location
            const annotationId = queryParamDataExt?.annotationId;
            // Set the thread key to the annotationId of the parent comment we're replying to
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
            // Access author field - both types have this field
            const author = commentWithAuthor?.author;
            // Set up reply state
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        replyToCommentId,
        foundComment,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $cozmU.useCallback)(()=>{
        return $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $1ZGYV.useRetryOnMutation)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $cozmU.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location } = queryParamData;
        const { annotationId: annotationId } = queryParamDataExt;
        if (location) {
            if (queryParamDataExt.isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (annotationId) {
                    setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                }
            } else if (annotationId && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                // rendererActions is populated asynchronously — wait for it before checking
                // annotation marks, otherwise we'd incorrectly treat active comments as dangling
                // and open an empty DELETED_CONTENT panel (the check below latches via
                // hasHandledCommentLink, so a premature run never recovers). The effect re-runs
                // when rendererActions becomes available (it is a dependency).
                if (!rendererActions) return;
                // Comment exists in DB (location is truthy) but annotation mark may be gone from page content.
                // Check if annotation mark exists in renderer; if not, open DELETED_CONTENT panel.
                const marks = rendererActions.getAnnotationMarks();
                // The renderer can briefly report ZERO marks while it (re)hydrates the document during
                // load (observed transitioning 6 -> 0 -> 6). Concluding "dangling" during that window
                // opens an empty DELETED_CONTENT panel and latches it via hasHandledCommentLink, so it
                // never recovers. Requiring at least one mark closes that race — this is the view-path
                // counterpart of the editor fix for bug #19 (which uses annotations.length > 0). Gated to
                // match the editor fix's rollout (confluence_focused_comment_empty_annotation_check).
                if ((!marks || marks.length === 0) && (0, $9wGTI.fg)('confluence_focused_comment_empty_annotation_check')) return;
                const annotationExists = marks?.some((mark)=>mark.attrs?.id === annotationId);
                if (!annotationExists) {
                    setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId);
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
                    hasHandledCommentLink.current = true;
                    return;
                }
            }
        } else {
            // Wait for the comment query to finish before checking if annotation exists
            // This prevents race condition where we check before comment data is available
            // Only apply this check when the feature flag is enabled
            if ((0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) {
                // Wait for renderer actions and comment query to finish (isCommentNotFound is undefined while query is loading)
                if (!rendererActions || annotationId && isCommentNotFound === undefined) return;
            }
            // Check if annotation exists in renderer only when we need to make the decision
            // Ensure rendererActions is available before accessing it
            if (!rendererActions && (0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) return;
            const annotationExists = rendererActions?.getAnnotationMarks()?.some((mark)=>mark.attrs.id === annotationId);
            if (annotationId && !annotationExists && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE); // needed so that the view knows which thread to scroll to after rendering the threads
                setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
            }
            hasHandledCommentLink.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        queryParamData,
        rendererActions,
        orderedActiveAnnotationIdList
    ]);
    // Only display the "comment not found" flag once
    (0, $cozmU.useEffect)(()=>{
        if (isCommentNotFound) {
            const VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID = `viewpage-comment-link-not-found-${commentId}`;
            flags.showWarningFlag({
                id: VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        }
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
const $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        // If the already open container is showing the correct comment, don't send another click event to open it
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        // Deep-link scrolling: unified navigation when we have a comment id; otherwise scroll to the mark
        // (replies skip mark-only scroll here — reply scrolling runs after the reply renders to avoid double scroll)
        if (commentId) {
            const success = (0, $9FoVw.handleDeepLinkNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: 'center',
                markElement: mark,
                commentId: commentId
            });
            if (!success) {
                (0, $a33Aa.abortAll)('new_interaction', `focused-comment-scroll`);
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        } else if (!parentId) {
            (0, $a33Aa.abortAll)('new_interaction', `focused-comment-scroll`);
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
    }
    return !!mark;
};
const $61084f20d36cc3f6$var$withInlineCommentQueryParamUnification = (Component)=>(props)=>{
        if ((0, $9wGTI.fg)('confluence_comment_param_unification')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifBRq.CommentQueryParamsListener), {
            isArchived: props.isArchived,
            rendererRef: props.rendererRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
    };
const $61084f20d36cc3f6$export$34418bee20f397f = (0, $7aRa9.withFlags)($61084f20d36cc3f6$var$withInlineCommentQueryParamUnification($61084f20d36cc3f6$export$3cf51438c4a7a1a));






var $a8ZQ3 = parcelRequire("a8ZQ3");







const $f7fdc9c663d47c5a$export$2f2529470fc43ad6 = /*#__PURE__*/ (0, $cozmU.memo)(({ actions: actions, pageId: pageId })=>{
    const { setRendererActions: setRendererActions } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $cozmU.useEffect)(()=>{
        setRendererActions(actions, pageId);
    }, [
        actions,
        pageId,
        setRendererActions
    ]);
    return null;
});






var $804Ue = parcelRequire("804Ue");
/* eslint-disable import/no-duplicates */ 



var $epbW8 = parcelRequire("epbW8");


var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");





var $aMfLn = parcelRequire("aMfLn");

















var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");


var $cD1qu = parcelRequire("cD1qu");


var $3BPrE = parcelRequire("3BPrE");


var $b11gn = parcelRequire("b11gn");


var $2QXMk = parcelRequire("2QXMk");

const $039e5ede5bcb8619$var$sendFailedPubsubEvent = ({ createAnalyticsEvent: createAnalyticsEvent, publishVersionNumber: publishVersionNumber, publishedDocumentVersion: publishedDocumentVersion })=>{
    if (createAnalyticsEvent && publishVersionNumber && publishedDocumentVersion) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'failed',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments',
            attributes: {
                stepVersion: publishVersionNumber,
                documentVersion: publishedDocumentVersion
            }
        }
    }).fire();
};
const $039e5ede5bcb8619$var$isEventCommentThreadOpen = (markerRef)=>{
    if (!markerRef) return false;
    if (typeof document !== 'undefined') {
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        // Figure out if the reply's parent markerRef is open
        // HACK: Is there a way to do this without query selectors?
        return focusedMarkerRef && focusedMarkerRef.id === markerRef;
    }
    return false;
};
const $039e5ede5bcb8619$export$4197a8a52311d1d2 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent })=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'received',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments'
        }
    }).fire();
    const { markerRef: markerRef, step: step, publishVersionNumber: publishVersionNumber } = inlineCommentRequestBody;
    // If the users content is out of date or different, the steps from this pubsub event will be wrong
    // The new comment flag shown by VQR will be triggered to refetch the content
    if (step && publishVersionNumber === publishedDocumentVersion && !needsContentUpdate) {
        const { to: to, from: from, pos: pos, mark: { attrs: { annotationType: annotationType } } } = step;
        const position = pos !== undefined && pos !== null ? {
            to: pos,
            from: pos
        } : {
            to: to,
            from: from
        };
        const annotation = {
            annotationId: markerRef,
            annotationType: annotationType
        };
        const result = rendererActions?.applyAnnotation(position, annotation);
        if (result) updateDocument && updateDocument(result.doc);
    } else {
        if (!needsContentUpdate) setContentNeedsUpdate && setContentNeedsUpdate(true);
        // If we can't apply the step, send an event
        $039e5ede5bcb8619$var$sendFailedPubsubEvent({
            createAnalyticsEvent: createAnalyticsEvent,
            publishVersionNumber: publishVersionNumber,
            publishedDocumentVersion: publishedDocumentVersion
        });
    }
};
const $039e5ede5bcb8619$export$14eb0441cdcaaa35 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, eventEmitter: eventEmitter })=>{
    const { markerRef: markerRef } = inlineCommentRequestBody;
    if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) eventEmitter?.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
    const deleteResult = rendererActions?.deleteAnnotation(markerRef, (0, $epbW8.AnnotationTypes).INLINE_COMMENT);
    if (deleteResult) updateDocument && updateDocument(deleteResult.doc);
};
let $039e5ede5bcb8619$var$pagePublicationEventParams = {};
const $039e5ede5bcb8619$var$setPagePublicationEventParams = (params)=>{
    $039e5ede5bcb8619$var$pagePublicationEventParams = params;
};
const $039e5ede5bcb8619$var$onPagePublicationEvent = async (event, payload)=>{
    let confVersion;
    let trigger;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        confVersion = payload.pageUpdated.confVersion;
        trigger = payload.pageUpdated.trigger;
    } else {
        confVersion = payload.pageUpdatedRequestBody.confVersion;
        trigger = payload.pageUpdatedRequestBody.trigger;
    }
    const { setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, setPublishedDocumentVersion: setPublishedDocumentVersion } = $039e5ede5bcb8619$var$pagePublicationEventParams;
    // need to modify this for subscriptions since the event wont have avi/know content type this way
    // myabe the type in the page updated response will be what we want
    // if pageupdated trigger is publish
    if ((event === (0, $3BPrE.PagePubSubEvents).PagePublished || event === (0, $3BPrE.PagePubSubEvents).BlogPublished || event === (0, $3BPrE.PageSubscriptionEvents).PageUpdated && trigger === 'publish') && publishedDocumentVersion !== confVersion) {
        // TODO: Eventually we want to read the values passed to us to see if this is positional breaking
        setContentNeedsUpdate && setContentNeedsUpdate(true);
        if ((0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setPublishedDocumentVersion && setPublishedDocumentVersion(confVersion);
    }
};
let $039e5ede5bcb8619$var$commentPublicationEventParams = {};
const $039e5ede5bcb8619$export$11d6bf62aa2fcbf9 = (params)=>{
    $039e5ede5bcb8619$var$commentPublicationEventParams = params;
};
const $039e5ede5bcb8619$export$8579923c4bc2600 = async (event, payload)=>{
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const { accountId: accountId } = payload;
    let inlineCommentRequestBody;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) inlineCommentRequestBody = payload?.[event];
    else inlineCommentRequestBody = payload.inlineCommentRequestBody;
    const { inlineCommentType: inlineCommentType, markerRef: markerRef, commentId: commentId } = inlineCommentRequestBody || {};
    const isReply = inlineCommentType === 'REPLY';
    const { contentId: contentId, currentUserId: currentUserId, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = $039e5ede5bcb8619$var$commentPublicationEventParams;
    // Don't do anything when the current user performs an action, unless we need to process their reply.
    if ((0, $2QXMk.shouldSkipOwnPubSubEvent)({
        accountId: accountId,
        currentUserId: currentUserId,
        isReply: isReply,
        isOwnReplyPubSubProcessingEnabled: (0, $6mKj3.expVal)('cc_comments_pubsub_process_own_replies', 'isEnabled', false)
    })) return;
    const { start: startCommentsPubSubExperience, succeed: succeedCommentsPubSubExperience, fail: failCommentsPubSubExperience } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).RendererInlineCommentsPubSub);
    startCommentsPubSubExperience(event);
    try {
        // These promises were previously dispatched as fire-and-forget (`void`).
        // Arguably they should be awaited, but until they are, we keep track of
        // their failures by collecting them here and awaiting `Promise.all` at
        // the end so any rejection becomes a `fail` on the experience and a
        // successful resolution becomes a `succeed`.
        const trackedPromises = [];
        switch(event){
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
                if (event) {
                    if (commentId && contentId) {
                        // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        // Synchronously process the updated comment data cache to get it added to the open
                        // comments array. If we don't manually do this now, the updated cache isn't processed
                        // until the next render cycle when useAllCommentsDataQuery updates, which is too late
                        // for the updateRendererAnnotations() call below. If the comment is not in the open
                        // array at that time, the annotation is not added to the orderedActiveAnnotationIdList
                        // and the reopened comment then appears to be attached to deleted content.
                        const updatedCachedData = (0, $NYiei.getCommentsDataFromCache)(contentId);
                        (0, $4L9ve.getProcessedCommentsDataActions)().processCommentsData({
                            data: updatedCachedData,
                            pageMode: (0, $cD1qu.PageMode).VIEW
                        });
                    }
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (markerRef && reopenParentComment) reopenParentComment({
                        threadKey: markerRef,
                        commentType: (0, $kgNLQ.CommentType).INLINE,
                        parentCommentId: commentId
                    });
                }
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [markerRef]: {
                        id: markerRef,
                        annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $epbW8.AnnotationMarkStates).ACTIVE
                    }
                });
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
                // If the thread is open, close it and clear highlight
                if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) {
                    eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                    if ((0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setActiveHighlight?.(null);
                }
                // Remove the resolved comment from the navigation list
                if (setOrderedActiveAnnotationIdList && orderedActiveAnnotationIdList && (0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== markerRef));
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [markerRef]: {
                        id: markerRef,
                        annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $epbW8.AnnotationMarkStates).RESOLVED
                    }
                });
                if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                trackedPromises.push((0, $lb2Lp.fetchCommentById)({
                    commentId: commentId,
                    contentId: contentId,
                    fetchPolicy: 'network-only'
                }));
                const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                updateRemovedCommentIdsMap && inlineResolveProperties && inlineText && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                    isReply: isReply,
                    commentType: (0, $kgNLQ.CommentType).INLINE,
                    resolvedProperties: {
                        inlineResolveProperties: inlineResolveProperties,
                        inlineText: inlineText
                    }
                });
                const { replies: replies = [] } = inlineCommentRequestBody;
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId,
                    ...replies
                ]), 'remove');
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated:
                if (inlineCommentType === 'TOP_LEVEL') {
                    if (addCommentInCache && commentId && contentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment,
                            onError: failCommentsPubSubExperience
                        });
                        // This needs to happen AFTER the cache update. applyStepAndAddCommentToDoc triggers the doc to re-render, which triggers getRendererAnnotationStates
                        // getRendererAnnotationStates pulls data from the cache to determine which annotations to show
                        // In the legacy version this wasn't a problem, since it does a full network call
                        $039e5ede5bcb8619$export$4197a8a52311d1d2({
                            inlineCommentRequestBody: inlineCommentRequestBody,
                            rendererActions: rendererActions,
                            updateDocument: updateDocument,
                            needsContentUpdate: needsContentUpdate,
                            setContentNeedsUpdate: setContentNeedsUpdate,
                            publishedDocumentVersion: publishedDocumentVersion,
                            createAnalyticsEvent: createAnalyticsEvent
                        });
                    }
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                } else if (isReply) {
                    if (addCommentInCache && commentId && contentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment,
                            onError: failCommentsPubSubExperience
                        });
                    }
                    if (updateUnreadCommentIDSet && accountId !== currentUserId) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                }
                break;
            // just for replies
            case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
                if (isReply) {
                    if (addCommentInCache && commentId && contentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment,
                            onError: failCommentsPubSubExperience
                        });
                    }
                    if (typeof document !== 'undefined') {
                        // Check if the annotation exists in the renderer DOM before updating unread comments
                        const annotationElement = document.getElementById(markerRef);
                        if (annotationElement && updateUnreadCommentIDSet && accountId !== currentUserId) updateUnreadCommentIDSet(new Set([
                            commentId
                        ]), 'add');
                    }
                }
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
                // Always handle annotation logic
                if (inlineCommentType === 'TOP_LEVEL') $039e5ede5bcb8619$export$14eb0441cdcaaa35({
                    inlineCommentRequestBody: inlineCommentRequestBody,
                    rendererActions: rendererActions,
                    updateDocument: updateDocument,
                    eventEmitter: eventEmitter
                });
                if (deleteCommentInCache && commentId) deleteCommentInCache({
                    commentId: commentId,
                    onError: failCommentsPubSubExperience
                });
                // both a parent comment and reply can be deleted
                updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    isReply: isReply,
                    commentType: (0, $kgNLQ.CommentType).INLINE
                });
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId
                ]), 'remove');
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached:
                $039e5ede5bcb8619$export$4197a8a52311d1d2({
                    inlineCommentRequestBody: inlineCommentRequestBody,
                    rendererActions: rendererActions,
                    updateDocument: updateDocument,
                    needsContentUpdate: needsContentUpdate,
                    setContentNeedsUpdate: setContentNeedsUpdate,
                    publishedDocumentVersion: publishedDocumentVersion,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
                // If the initial comment thread is open, refresh it
                if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                trackedPromises.push((0, $lb2Lp.fetchCommentById)({
                    commentId: commentId,
                    contentId: contentId,
                    fetchPolicy: 'network-only'
                }));
                break;
            default:
                failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                break;
        }
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
            if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted) {
                if (rendererActions && contentId && updateUnresolvedInlineComment) trackedPromises.push((0, $aMfLn.updateRendererAnnotations)({
                    rendererActions: rendererActions,
                    contentId: contentId,
                    updateUnresolvedInlineComment: updateUnresolvedInlineComment
                }));
            }
        } else {
            // Always update if we've handled the event
            if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted) {
                if (rendererActions && contentId && updateUnresolvedInlineComment) trackedPromises.push((0, $aMfLn.updateRendererAnnotations)({
                    rendererActions: rendererActions,
                    contentId: contentId,
                    updateUnresolvedInlineComment: updateUnresolvedInlineComment
                }));
            }
        }
        await Promise.all(trackedPromises);
        succeedCommentsPubSubExperience();
    } catch (error) {
        failCommentsPubSubExperience(error);
        throw error;
    }
};
function $039e5ede5bcb8619$export$9ac99a17b366f8ef({ contentId: contentId, currentUserId: currentUserId, contentType: contentType, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, setContentNeedsUpdate: setContentNeedsUpdate, needsContentUpdate: needsContentUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, addSubscriber: addSubscriber, setContentId: setContentId, setContentType: setContentType, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }) {
    const pubSubResourceType = contentType || 'page';
    $039e5ede5bcb8619$export$11d6bf62aa2fcbf9({
        contentId: contentId,
        currentUserId: currentUserId,
        rendererActions: rendererActions,
        updateDocument: updateDocument,
        updateUnresolvedInlineComment: updateUnresolvedInlineComment,
        needsContentUpdate: needsContentUpdate,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        createAnalyticsEvent: createAnalyticsEvent,
        updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
        reopenParentComment: reopenParentComment,
        updateUnreadCommentIDSet: updateUnreadCommentIDSet,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache,
        setActiveHighlight: setActiveHighlight,
        setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
    });
    $039e5ede5bcb8619$var$setPagePublicationEventParams({
        currentUserId: currentUserId,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        setPublishedDocumentVersion: setPublishedDocumentVersion
    });
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentId || !setContentType) return;
        const subscriptions = [];
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentResolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentResolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUnresolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUnresolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubRendererInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'rendererInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubEditorInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'editorInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentDeleted',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentDeleted'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentReattached',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentReattached'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUpdated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUpdated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubPageUpdated',
                onSubscriptionData: $039e5ede5bcb8619$var$onPagePublicationEvent,
                delta: 'pageUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriptions.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriptions;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        }).catch((error)=>{
            throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error)}`);
        });
    });
}
function $039e5ede5bcb8619$export$d3539dc2c41bd511({ contentId: contentId, contentType: contentType, subscriptions: subscriptions, removeSubscriber: removeSubscriber }) {
    const pubSubResourceType = contentType || 'page';
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) for (const subscriber of subscriptions)removeSubscriber?.(subscriber);
    else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
    });
}



var $fgQGl = parcelRequire("fgQGl");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $k8e76 = parcelRequire("k8e76");


var $9jl6v = parcelRequire("9jl6v");


var $fHAwL = parcelRequire("fHAwL");


var $bQm3c = parcelRequire("bQm3c");


var $7boqA = parcelRequire("7boqA");


var $a3q17 = parcelRequire("a3q17");





var $WheoQ = parcelRequire("WheoQ");




/**
 * @generated SignedSource<<270a8763bde6e8a6b1f015f9a7a2f8e7>>
 * @relayHash 8a0218b2e1c99a56ce8c33454f5c992d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240
const $9a2dad19e5d5deeb$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "highlightOptionPanelEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "8a0218b2e1c99a56ce8c33454f5c992d",
            "id": "0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240",
            "metadata": {},
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "operationKind": "query",
            "text": "query useIsHighlightOptionPanelEnabledQuery{userPreferences{highlightOptionPanelEnabled}}"
        }
    };
}();
$9a2dad19e5d5deeb$var$node.hash = "f1838f0592c7a8f202fdc84d54752216";
var $9a2dad19e5d5deeb$export$2e2bcd8739ae039 = $9a2dad19e5d5deeb$var$node;









var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $dc4cdd28902d8267$export$6bf92d32985d66db = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $9a2dad19e5d5deeb$export$2e2bcd8739ae039), {
        fetchPolicy: 'cache-and-network',
        skip: !userId,
        __callerPackage__: "comments-util"
    });
    return (0, $cozmU.useMemo)(()=>{
        // We always want to default to true until we get a result
        let isHighlightOptionPanelEnabled = true;
        if (error) // We always want to handle errors caused from this, just default to existing behavior
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!loading && data?.userPreferences) isHighlightOptionPanelEnabled = data?.userPreferences.highlightOptionPanelEnabled;
        return {
            isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled
        };
    }, [
        data,
        loading,
        error
    ]);
};



var $fFRTr = parcelRequire("fFRTr");


const $24269a0cd7d91594$var$SelectionComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GK726",
    name: "SelectionComponentLoader",
    loader: async ()=>(await (parcelRequire("ft1Qx"))).SelectionComponent
});

const $24269a0cd7d91594$var$HoverComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8tl48",
    name: "HoverComponentLoader",
    loader: async ()=>(await (parcelRequire("7mbR0"))).HoverComponent
});

const $24269a0cd7d91594$var$ViewComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HAh0o",
    name: "ViewComponentLoader",
    loader: async ()=>(await (parcelRequire("gMGCC"))).ViewComponent
});

const $24269a0cd7d91594$var$InlineCommentLinkHandlerLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0Ufwq",
    name: "InlineCommentLinkHandlerLoader",
    loader: async ()=>(await (parcelRequire("3EC4N"))).InlineCommentLinkHandler
});
const $24269a0cd7d91594$var$InlineCommentsPubSubHandler = ({ contentId: contentId, contentType: contentType, updateDocument: updateDocument, rendererActions: rendererActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setDocumentUpdated: setDocumentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $cozmU.useRef)([]);
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment } = (0, $8i27m.useCommentsDataActions)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)() || {};
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    const unsubscribeFromPubSub = (0, $cozmU.useCallback)(()=>{
        if (subscriptions.current.length === 0) return;
        (0, $039e5ede5bcb8619$export$d3539dc2c41bd511)({
            contentId: contentId,
            contentType: contentType,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current
        });
        subscriptions.current = [];
    }, [
        contentId,
        contentType,
        removeSubscriber
    ]);
    const subscribeToPubSub = (0, $cozmU.useCallback)(()=>{
        if (subscriptions.current.length > 0) // Multiple active subscriptions will cause multiple cache-writes, which we don't want.
        // Instead of returning early here, we unsub + resub so that values in setUpRendererInlineCommentsPubSub stay up to date.
        unsubscribeFromPubSub();
        subscriptions.current = (0, $039e5ede5bcb8619$export$9ac99a17b366f8ef)({
            contentId: contentId,
            currentUserId: userId,
            contentType: contentType,
            rendererActions: rendererActions,
            updateDocument: updateDocument,
            updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn,
            setContentNeedsUpdate: setDocumentNeedsUpdate,
            needsContentUpdate: Boolean(documentNeedsUpdate),
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            publishedDocumentVersion: publishedDocumentVersion,
            createAnalyticsEvent: createAnalyticsEvent,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            setActiveHighlight: setActiveHighlight,
            setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
        }) || [];
        return subscriptions.current;
    // We only need to respond to values that CAN change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        userId,
        contentType,
        rendererActions,
        documentNeedsUpdate,
        publishedDocumentVersion,
        addSubscriber,
        setContentType,
        setContentId,
        addCommentInCache,
        deleteCommentInCache,
        unsubscribeFromPubSub
    ]);
    const handleFetchContentVersionEvent = (0, $cozmU.useCallback)(()=>{
        setDocumentNeedsUpdate(true);
    }, [
        setDocumentNeedsUpdate
    ]);
    const handleEventFetchSuccess = (0, $cozmU.useCallback)((res)=>{
        // TODO: Parse the events returned for 'resolved', 'unresolved', and 'delete' when they are added
        //       for now we just reload the content when the user comes back
        // For now all we have is create events, which means we will miss things, but only update if a new ones were created
        if (res.commentEvents.length > 0) {
            setDocumentUpdated(true);
            setRefetchContent(true);
        }
    }, [
        setRefetchContent,
        setDocumentUpdated
    ]);
    if (!userId) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).INLINE,
        subscribeToPubSubEvents: subscribeToPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onFetchContentVersionEvent: handleFetchContentVersionEvent,
        inactiveInterval: 0,
        returnInterval: 0
    });
};
const $24269a0cd7d91594$var$WithAnnotationsWrapperComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { flags: flags, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, updateDocument: updateDocument, isNestedRender: t1, children: children, lastModifiedDate: lastModifiedDate, isArchived: t2 } = t0;
    const isNestedRender = t1 === undefined ? false : t1;
    const isArchived = t2 === undefined ? false : t2;
    const { setDocumentUpdated: setDocumentUpdated, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { refetchContent: refetchContent } = (0, $5pQ1Y.useContentRefetch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const [t3] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, contentType: contentType } = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { selectionProps: selectionProps, viewProps: viewProps, hoverProps: hoverProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled } = (0, $dc4cdd28902d8267$export$6bf92d32985d66db)();
    const handleAnnotationsLoaded = $24269a0cd7d91594$var$_temp;
    let t4;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== createAnalyticsEvent || $[3] !== flags || $[4] !== setDocumentNeedsUpdate || $[5] !== setDocumentUpdated || $[6] !== setPublishedDocumentVersion || $[7] !== setRefetchContent) {
        t4 = (versionNumber)=>{
            setRefetchContent(false);
            setDocumentUpdated(true);
            setDocumentNeedsUpdate(false);
            flags.hideAllFlags();
            if (versionNumber) setPublishedDocumentVersion(versionNumber);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "refetched",
                    actionSubject: "content",
                    objectId: contentId,
                    contentType: contentType,
                    source: "viewPageScreen"
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = flags;
        $[4] = setDocumentNeedsUpdate;
        $[5] = setDocumentUpdated;
        $[6] = setPublishedDocumentVersion;
        $[7] = setRefetchContent;
        $[8] = t4;
    } else t4 = $[8];
    const handleOnRefetchComplete = t4;
    let t5;
    if ($[9] !== adfDocument || $[10] !== annotationProvider || $[11] !== children || $[12] !== contentId || $[13] !== contentType || $[14] !== handleOnRefetchComplete || $[15] !== hoverProps || $[16] !== isArchived || $[17] !== isHighlightOptionPanelEnabled || $[18] !== isNestedRender || $[19] !== isOffline || $[20] !== lastModifiedDate || $[21] !== refetchContent || $[22] !== rendererRef || $[23] !== selectionProps || $[24] !== updateDocument || $[25] !== viewProps) {
        t5 = annotationProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35beb435b76f50f4$export$f9718e664221d42a), {
            render: (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                    key: contentId,
                    metric: (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $WNsSX.AnnotationsWrapper), {
                    rendererRef: rendererRef,
                    adfDocument: adfDocument,
                    annotationProvider: annotationProvider,
                    isNestedRender: isNestedRender,
                    onLoadComplete: handleAnnotationsLoaded
                }, !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0779e224f4e996ea$export$6f846e47e87c2a09), null), selectionProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$SelectionComponentLoader, {
                    ...selectionProps,
                    isOffline: isOffline,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    adfDocument: adfDocument,
                    getSelectionContext: ()=>actions.getSelectionContext(),
                    isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled
                }), hoverProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$HoverComponentLoader, {
                    ...hoverProps,
                    isOffline: isOffline
                }), viewProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$ViewComponentLoader, {
                    ...viewProps,
                    isOffline: isOffline
                }), children), !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61084f20d36cc3f6$export$34418bee20f397f), {
                    isArchived: isArchived,
                    rendererRef: rendererRef
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7fdc9c663d47c5a$export$2f2529470fc43ad6), {
                    actions: actions,
                    pageId: contentId
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$InlineCommentsPubSubHandler, {
                    contentId: contentId,
                    contentType: contentType,
                    updateDocument: updateDocument,
                    rendererActions: actions
                }), contentId && (0, $6mKj3.expValEquals)("confluence_inline_reactions", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fFRTr.InlineReactionsPubSubHandler), {
                    contentId: contentId,
                    contentType: contentType === "blogpost" ? "blogpost" : "page",
                    rendererActions: actions,
                    updateDocument: updateDocument
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fgQGl.ContentRefetchHandler), {
                    contentId: contentId,
                    shouldRefetch: refetchContent,
                    refetchImmediately: true,
                    onRefetchComplete: handleOnRefetchComplete
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$InlineCommentLinkHandlerLoader, null))
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children));
        $[9] = adfDocument;
        $[10] = annotationProvider;
        $[11] = children;
        $[12] = contentId;
        $[13] = contentType;
        $[14] = handleOnRefetchComplete;
        $[15] = hoverProps;
        $[16] = isArchived;
        $[17] = isHighlightOptionPanelEnabled;
        $[18] = isNestedRender;
        $[19] = isOffline;
        $[20] = lastModifiedDate;
        $[21] = refetchContent;
        $[22] = rendererRef;
        $[23] = selectionProps;
        $[24] = updateDocument;
        $[25] = viewProps;
        $[26] = t5;
    } else t5 = $[26];
    return t5;
};
const $24269a0cd7d91594$export$548dda15276d1592 = (0, $7aRa9.withFlags)($24269a0cd7d91594$var$WithAnnotationsWrapperComponent);
function $24269a0cd7d91594$var$_temp(t0) {
    const { numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments } = t0;
    const options = {
        customData: {
            isFabricPage: true,
            numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments
        }
    };
    (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC).stop(options);
}
module.exports["WithAnnotationsWrapper"] = $24269a0cd7d91594$export$548dda15276d1592;

});

parcelRegister("ft1Qx", function(module, exports) {

let $b42aff15c89b6e7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b42aff15c89b6e7e$var$load("ccAQf"),
    $b42aff15c89b6e7e$var$load("bwLq7"),
    $b42aff15c89b6e7e$var$load("fH3TJ"),
    $b42aff15c89b6e7e$var$load("ipLRb"),
    $b42aff15c89b6e7e$var$load("5RCVQ"),
    $b42aff15c89b6e7e$var$load("hUbK8"),
    $b42aff15c89b6e7e$var$load("6wr18"),
    $b42aff15c89b6e7e$var$load("9o0Ua"),
    $b42aff15c89b6e7e$var$load("3fdX4"),
    $b42aff15c89b6e7e$var$load("kZsda"),
    $b42aff15c89b6e7e$var$load("VYd77"),
    $b42aff15c89b6e7e$var$load("lAQZi"),
    $b42aff15c89b6e7e$var$load("cXgsM"),
    $b42aff15c89b6e7e$var$load("1jVx9"),
    $b42aff15c89b6e7e$var$load("byAMe"),
    $b42aff15c89b6e7e$var$load("lpqsT"),
    $b42aff15c89b6e7e$var$load("c0XG0"),
    $b42aff15c89b6e7e$var$load("9jAJl"),
    $b42aff15c89b6e7e$var$load("b0ARW"),
    $b42aff15c89b6e7e$var$load("jomLJ"),
    $b42aff15c89b6e7e$var$load("ioRQV"),
    $b42aff15c89b6e7e$var$load("j5RRe"),
    $b42aff15c89b6e7e$var$load("7TyQi"),
    $b42aff15c89b6e7e$var$load("j5uGx"),
    $b42aff15c89b6e7e$var$load("8ggEZ"),
    $b42aff15c89b6e7e$var$load("gXS72"),
    $b42aff15c89b6e7e$var$load("5fGvF"),
    $b42aff15c89b6e7e$var$load("TfSzW"),
    $b42aff15c89b6e7e$var$load("ceyL9"),
    $b42aff15c89b6e7e$var$load("eeYoU"),
    $b42aff15c89b6e7e$var$load("18viy"),
    $b42aff15c89b6e7e$var$load("ltXZd"),
    $b42aff15c89b6e7e$var$load("d64xd"),
    $b42aff15c89b6e7e$var$load("lhLGe"),
    $b42aff15c89b6e7e$var$load("8STUC"),
    $b42aff15c89b6e7e$var$load("7Hb14"),
    $b42aff15c89b6e7e$var$load("kSgPY"),
    $b42aff15c89b6e7e$var$load("gJqWO"),
    $b42aff15c89b6e7e$var$load("dZYhM"),
    $b42aff15c89b6e7e$var$load("aEiTV"),
    $b42aff15c89b6e7e$var$load("iYzdG"),
    $b42aff15c89b6e7e$var$load("aMsb0"),
    $b42aff15c89b6e7e$var$load("2PXrC"),
    $b42aff15c89b6e7e$var$load("gcLWi"),
    $b42aff15c89b6e7e$var$load("fsgrC"),
    $b42aff15c89b6e7e$var$load("eqj21"),
    $b42aff15c89b6e7e$var$load("3oAU3"),
    $b42aff15c89b6e7e$var$load("5k0cI"),
    $b42aff15c89b6e7e$var$load("aM9Md"),
    $b42aff15c89b6e7e$var$load("1f0Jg"),
    $b42aff15c89b6e7e$var$load("aQ52k"),
    $b42aff15c89b6e7e$var$load("eHgxr"),
    $b42aff15c89b6e7e$var$load("1qlDN"),
    $b42aff15c89b6e7e$var$load("1yVM6"),
    $b42aff15c89b6e7e$var$load("Wowvf"),
    $b42aff15c89b6e7e$var$load("7EorR"),
    $b42aff15c89b6e7e$var$load("hhss7"),
    $b42aff15c89b6e7e$var$load("ffEVr"),
    $b42aff15c89b6e7e$var$load("eiF7i"),
    $b42aff15c89b6e7e$var$load("gl4lh")
]).then(()=>parcelRequire('11FDr'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("7mbR0", function(module, exports) {

let $55b3c869a28491e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $55b3c869a28491e3$var$load("5k0cI"),
    $55b3c869a28491e3$var$load("aM9Md"),
    $55b3c869a28491e3$var$load("bwLq7"),
    $55b3c869a28491e3$var$load("fH3TJ"),
    $55b3c869a28491e3$var$load("ipLRb"),
    $55b3c869a28491e3$var$load("5RCVQ"),
    $55b3c869a28491e3$var$load("6wr18"),
    $55b3c869a28491e3$var$load("adnVr"),
    $55b3c869a28491e3$var$load("kZsda"),
    $55b3c869a28491e3$var$load("jdmfD"),
    $55b3c869a28491e3$var$load("1jVx9"),
    $55b3c869a28491e3$var$load("cJsay"),
    $55b3c869a28491e3$var$load("1GCFv"),
    $55b3c869a28491e3$var$load("byAMe"),
    $55b3c869a28491e3$var$load("agaLh"),
    $55b3c869a28491e3$var$load("ffEVr"),
    $55b3c869a28491e3$var$load("4W6oq"),
    $55b3c869a28491e3$var$load("7EorR"),
    $55b3c869a28491e3$var$load("jqoep"),
    $55b3c869a28491e3$var$load("18ilu")
]).then(()=>parcelRequire('3Xs7k'));

});

parcelRegister("gMGCC", function(module, exports) {

let $c38230d73da55757$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c38230d73da55757$var$load("dPFEi"),
    $c38230d73da55757$var$load("3zT1X"),
    $c38230d73da55757$var$load("5k0cI"),
    $c38230d73da55757$var$load("aM9Md"),
    $c38230d73da55757$var$load("bwLq7"),
    $c38230d73da55757$var$load("fH3TJ"),
    $c38230d73da55757$var$load("dDCJZ"),
    $c38230d73da55757$var$load("79Tk4"),
    $c38230d73da55757$var$load("ipLRb"),
    $c38230d73da55757$var$load("5RCVQ"),
    $c38230d73da55757$var$load("bl75H"),
    $c38230d73da55757$var$load("7z4yV"),
    $c38230d73da55757$var$load("6wr18"),
    $c38230d73da55757$var$load("adnVr"),
    $c38230d73da55757$var$load("lK9vp"),
    $c38230d73da55757$var$load("1jVx9"),
    $c38230d73da55757$var$load("dfVz8"),
    $c38230d73da55757$var$load("cJsay"),
    $c38230d73da55757$var$load("cupS9"),
    $c38230d73da55757$var$load("1GCFv"),
    $c38230d73da55757$var$load("byAMe"),
    $c38230d73da55757$var$load("aIw3f"),
    $c38230d73da55757$var$load("Wowvf"),
    $c38230d73da55757$var$load("4W6oq"),
    $c38230d73da55757$var$load("jqoep"),
    $c38230d73da55757$var$load("7EorR"),
    $c38230d73da55757$var$load("ffEVr"),
    $c38230d73da55757$var$load("fHwKU"),
    $c38230d73da55757$var$load("ipIDQ"),
    $c38230d73da55757$var$load("jsNWB"),
    $c38230d73da55757$var$load("kPE95"),
    $c38230d73da55757$var$load("gzrfp"),
    $c38230d73da55757$var$load("lpzz1")
]).then(()=>parcelRequire('fZ65r'));

});

parcelRegister("3EC4N", function(module, exports) {

let $2a92a4b63a5a59f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a92a4b63a5a59f2$var$load("l1bfS").then(()=>parcelRequire('4K1uG'));

});


//# sourceMappingURL=PageContentRendererFabric.fef06ff7.js.map
